import Tree from "rc-tree";
import { cloneDeep, each, set } from "lodash";
import "../../assets/css/rcTree.css";
import TreeLoading from "./TreeLoading";
import { useTranslation } from "react-i18next";
import { eachDeep } from "deepdash-es/standalone";
import { useSelector, useDispatch } from "react-redux";
import { treeActions } from "../../redux/slices/treeSlice";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import { scrollToSelectedItem } from "../../utils/utilFunctions";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import React, { useContext, useEffect, useRef, useState } from "react";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import { getSelectedNodes, getStartAndEndKey } from "../RightContextMenu/ContextActions/CopyAndPaste";
import { collectNodes, getKeys, getNodeParentsByAltId, getNodeParentsById, getNodeParentsByKey } from "./InboundTemplateTree";
import { addNodesAndUpdateTransData, nodesValidation, removeNodesAndUpdateTransData } from "../../utils/nodesValidation";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Badge } from "@mui/material";
import ErrorModal from "../ItemProperties/Forms/FieldDataValidation/ErrorModal";
import { getUpdatedData } from "../RightContextMenu/ContextActions/NewRecordOutbound";
import { getSameLevelOrAboveLevelNode } from "./WorkflowGroupsTree";
import Delete from "../RightContextMenu/ContextActions/Delete";
import { use } from "react";

export default function WorkflowTemplateTree(props) {
	const { expandActions } = props;
	
  const parentScreen = useContext(ParentScreenCtx);
  const dispatch = useDispatch();
	const { t } = useTranslation();

  const { account } = useSelector((state) => state.queryParams);
	const { leftTree, rightTree, recentlyVisitedTemplates } = useSelector(
		(state) => state.treeData.workflow
	);
  const { workflowGroup, title } = leftTree.tree.body.selectedNode;
	const translatedData = rightTree.tree.body.translatedData;
	const selectedNode = rightTree.tree.body.selectedNode;
  const currentTab = rightTree.currentTab;

  const treeParentRef = React.createRef();
	const manualClick = useRef(false);
  const treeRef = React.createRef();



	// const [show, setShow] = useState(false);
	// const [draggedWfg, setDraggedWfg] = useState();
	// const [selectedNodes, setSelectedNodes] = useState({});
	const [modalContent, setModalContent] = useState("");
	const [draggedNodes, setDraggedNodes] = useState([]);

	const [fromOnExpand, setFromOnExpand] = useState(false);
	const [selectedKeys, setSelectedKeys] = useState([]);
	const [expandedKeys, setExpandedKeys] = useState({});
	const [treeDisabled, setTreeDisabled] = useState(false);
	// const [treeFocused, setTreeFocused] = useState(false);
	const [showModal, setShowModal] = useState(false);
	const [draggedNodesPending, setDraggedNodesPending] = useState(); // This state will be used for storing nodes until user select any option in modal;
	const [errorModal, setErrorModal] = useState(false);
	const [errorMessage, setErrorMessage] = useState("");
	const [showDeleteModal, setShowDeleteModal] = useState(false);
	const templateHeader = rightTree.tree.templateHeader;
	
	const templatePath = `${account}/${workflowGroup}/${title}.json`;

	const modifyRecentVisitedTemplates = (node, tab) => {
	
	  if (node) {
		const { key } = node;
		let isModified = false;
		let templates = [];

		// Check if the node exists and update its position
		templates = recentlyVisitedTemplates.map(o => {
		  if (o.path === templatePath) {
			if (o.key !== key && o.tab === tab) {
			  isModified = true;
			  return { path: templatePath, key: key, tab: tab };
			}
			return o;
		  }
		  return o;
		});
	
		// If the node doesn't exist, add it to the array
		if (!recentlyVisitedTemplates.some(o => o.path === templatePath && o.tab === tab) && key && (key !== translatedData[0].key)) {
		  templates.push({ path: templatePath, key: key, tab: tab });
		  isModified = true;
		}
	
		// Dispatch the action only if the array has been modified
		if (isModified) {
		 dispatch(treeActions.setRecentlyVisitedTemplates({
			screen: parentScreen,
			value: templates
		  })
		)
		}
	  }
	};

	const onExpand = (keys, detail) => {
		updateNodesByKeys(keys, setExpandedKeys);
		//Removing Selected Node if its Parent Node is shrink
		if (selectedNode?.key?.includes(detail.node.key) && !detail.expanded) {
			setFromOnExpand(true);
			dispatch(
				treeActions.setRightTreeSelectedNode({
					screen: parentScreen,
					type: currentTab,
					data: detail.node,
				})
			);
			setSelectedKeys((prev) =>
				selectedKeys.filter((ele) => !ele?.includes(detail.node.key))
			);
			setSelectedKeys((prev) => [...prev, detail.node.key]);
		}
	};

	const onSelect = (keys, data) => {
		// TODO: find correct way to focus the tree when user clicks on it. (for using arrow keys and enter button, etc.)
		//treeRef.current.focus();
		// Added metaKey for the MACOS
		manualClick.current = true;
		let kb = {
			shift: data.nativeEvent ? data.nativeEvent.shiftKey : false,
			ctrl: data.nativeEvent ? data.nativeEvent.ctrlKey : false,
			metaKey: data.nativeEvent ? data.nativeEvent.metaKey : false,
		};

		if (!kb.ctrl && !kb.shift && !kb.metaKey) {
			setSelectedKeys((prev) => [data.node.key]);
		} else if ((kb.ctrl || kb.metaKey) && !kb.shift) {
			setSelectedKeys((prev) => (keys.length !== 0 ? keys : [data.node.key]));
		}
		if (kb.shift) {
			// this could get complicated
			// write a function that selects all nodes by key from LAST selected node to
			// CURRENT selected node in a linear way. Selecting cross-depth will need to be handled.
			if (keys.length > 1) {
				const data = rightTree.tree[currentTab].translatedData;
				const selectedKeys = getShiftSelectedKeys(keys, data);
				setSelectedKeys(selectedKeys);
			}
		}

		// Unselecting Node first (Some Component is using Ag-grid which is making closure with states) So by unselecting it is Unmonunting whole component completely;
		dispatch(
			treeActions.setRightTreeSelectedNode(
				cloneDeep({
					screen: parentScreen,
					type: currentTab,
					data: {
						avoidSelection: true,
					},
				})
			)
		);
		modifyRecentVisitedTemplates(data.node, currentTab)
		setTimeout(() => {
			dispatch(
				treeActions.setRightTreeSelectedNode({
					screen: parentScreen,
					type: rightTree.currentTab,
					data: {
						...data.node,
						avoidSelection: true,
					},
				})
			);
		});
	};

	useEffect(() => {
		dispatch(
		treeActions.setSelectedKeysArray({
			screen: parentScreen,
			type: rightTree.currentTab,
			data: selectedKeys,
		})
		);
		if (!manualClick.current) scrollToSelectedItem(selectedKeys, treeParentRef);
		manualClick.current = false;
  }, [selectedKeys]);

	const onDragStart = (info) => {
    info.event.dataTransfer.effectAllowed = "move";
    const draggedNodes = selectedKeys?.filter((e) => e === info.node.key)
      ?.length
      ? (getSelectedNodes(selectedKeys, translatedData, true) || [])?.map(
          (e) => e?.key
        )
      : (getSelectedNodes([info.node.key], translatedData, true) || [])?.map(
          (e) => e?.key
        );
    setDraggedNodes(draggedNodes);
  };

  const handleDialogShow = (modalText) => {
    setModalContent(formatModalContent(modalText));
    setShowModal(true);
  };

  const formatModalContent = (string) => {
    let splitText = string.split(`\\n`);

    return (
      <>
        {splitText[0]}
        <br />
        <br />
        {splitText[2]}
        <br />
        {splitText[3]} <br />
      </>
    );
  };

	//handle drop event
	const onDrop = (info) => {
		// Store original target position before removal for proper insertion calculation
		const originalTargetKey = info.node.key;
		const originalTargetNodeId = info.node.nodeId;
		const originalTargetIconDisplay = info.node.ICON_DISPLAY;
		
		let { updatedData, removedNodes } = removeNodesAndUpdateTransData(
			translatedData,
			draggedNodes,
			parentScreen,
			templateHeader?.FILETYPE,
			true,
			currentTab
		);

		eachDeep(removedNodes, (item) => {
			item?.POSITIONX !== undefined && delete item.POSITIONX;
			item?.POSITIONY !== undefined && delete item.POSITIONY;
		});

		// Find the target node in the updated data (after removal/reindexing)
		let updatedTargetNode = null;
		const findUpdatedTarget = (data) => {
			data.forEach(node => {
				if (node.nodeId === originalTargetNodeId && node.ICON_DISPLAY === info.node.ICON_DISPLAY) {
					updatedTargetNode = node;
					return;
				}
				if (node.children) findUpdatedTarget(node.children);
			});
		};
		findUpdatedTarget(updatedData);
		
		const targetNode = updatedTargetNode || info.node;
		
		const { errorMessage, modalMessage, isInside } = nodesValidation(
			targetNode,
			removedNodes,
			currentTab,
			true,
			templateHeader?.FILETYPE,
			updatedData,
      		parentScreen
		);

		if (modalMessage) {
			handleDialogShow(t(modalMessage));
			const selectedNodes = getSelectedNodes([targetNode.key], updatedData, true); // Use updated target node
			setDraggedNodesPending({ updatedData, removedNodes, node: selectedNodes || targetNode, originalTargetKey, originalTargetIconDisplay });
		} else if (errorMessage) {
			setErrorMessage(t(errorMessage));
			setErrorModal(true);
		} else if (!showModal && !errorMessage) {
			const {
				translatedData,
				selectedNode: finalNode,
				newSelectedKeys,
			} = addNodesAndUpdateTransData(
				updatedData,
				removedNodes,
				targetNode,
				isInside,
				templateHeader?.FILETYPE,
				currentTab,
				parentScreen,
				true
			);
			updateNewData(translatedData, finalNode, newSelectedKeys);
		}
	};

	const handleItemDrop = (isInside) => {
		const { updatedData, removedNodes, node, originalTargetIconDisplay } = draggedNodesPending;
		
		// Fix: Use the original target information to determine correct destination
		let destinationNode;
		let insertInside;
		
		if (node?.length === 2) {
			// Check which node was the actual drop target using originalTargetIconDisplay
			const targetIsElse = originalTargetIconDisplay === 'CONDITION_ELSE';
			
			if (targetIsElse) {
				// User dropped on ELSE node
				if (isInside) {
					// Yes - Insert inside ELSE node
					destinationNode = node[1];
					insertInside = true;
				} else {
					// No - Insert after IF node (before ELSE)
					destinationNode = node[0];
					insertInside = false;
				}
			} else {
				// User dropped on IF node
				if (isInside) {
					// Yes - Insert inside IF node
					destinationNode = node[0];
					insertInside = true;
				} else {
					// No - Insert after ELSE node (after the entire IF/ELSE block)
					destinationNode = node[1];
					insertInside = false;
				}
			}
		} else {
			destinationNode = node[0] || node;
			insertInside = isInside;
		}
		
		const { translatedData, selectedNode, newSelectedKeys } = addNodesAndUpdateTransData(updatedData, removedNodes, destinationNode, insertInside, templateHeader?.FILETYPE, currentTab, parentScreen, true);
		updateNewData(translatedData, selectedNode, newSelectedKeys);
		setShowModal(false);
	};

	const updateNewData = (finalData, finalNode, newSelectedKeys) => {
      const newUpdatedData = getUpdatedData(
        finalData,
        templateHeader?.FILETYPE,
		null,
		true,
		currentTab
      );
	  
      // Dispatching Empty Node first will clear all states in Middle Panel and then dispatching original node
      dispatch(
        treeActions.setRightTreeSelectedNode({
          screen: parentScreen,
          type: currentTab,
          data: {},
        })
      );
      setTimeout(() => {
        dispatch(
          treeActions.setRightTreeSelectedNode({
            screen: parentScreen,
            type: currentTab,
            data: { ...finalNode },
          })
        );
      });
      setSelectedKeys([finalNode?.key]);
      dispatch(
        treeActions.setRightTreeTransData({
          screen: parentScreen,
          type: currentTab,
          data: newUpdatedData,
        })
      );
    };

	const onRightClick = (info) => {
		if (!selectedKeys.includes(info.node.key) || selectedKeys.length < 2) {
			dispatch(
				treeActions.setRightTreeSelectedNode(
					cloneDeep({
						screen: parentScreen,
						type: currentTab,
						data: {
							avoidSelection: true,
						},
					})
				)
			);
			setTimeout(() => {
				dispatch(
					treeActions.setRightTreeSelectedNode(
						cloneDeep({
							screen: parentScreen,
							type: currentTab,
							data: {
								...info.node,
								avoidSelection: true,
							},
						})
					)
				);
			});
			setSelectedKeys([info.node.key]);
		}
	};

	const updateNodesByKeys = (keys, setState) => {
		let nodes = {}
		each(keys, (key) => {
			getNodeByKey(translatedData, key, (item) => {
				if(nodes?.hasOwnProperty(item.nodeId))
					nodes[`${item.alternateNodeId}_1`] = key;
				else
					nodes[item.alternateNodeId] = key;
			});
		})

		return setState(nodes);
	}

	const translatedDataKeys = getKeys(translatedData);
	const collectedNodes = collectNodes(translatedData);

	const handleKeyDown = (event) => {
		event.preventDefault();
		const expandAndCollapseNode = (isExpand) => {
			if (selectedNode?.children?.length && isExpand && !Object.values(expandedKeys)?.filter(e => e === selectedNode.key)?.length) {
				updateNodesByKeys([...Object.values(expandedKeys), selectedNode.key], setExpandedKeys);
			} else if (selectedNode?.children?.length && !isExpand && Object.values(expandedKeys)?.filter(e => e === selectedNode.key)?.length) {
				updateNodesByKeys(Object.values(expandedKeys).filter(e => e !== selectedNode.key), setExpandedKeys);
			}
		}	

		const navigate = (offset) => {
			if (selectedKeys.length === 0) return;
			const currentIndex = translatedDataKeys.reduce((acc, ele, index) => ele?.key === selectedKeys[0] ? index : acc, 0);
			let newIndex = currentIndex + offset;
			let nextNodeKey = translatedDataKeys[newIndex]?.key;
			let nextNode = collectedNodes[nextNodeKey];
			const sameLevelOrAboveLevelNodeIndex = getSameLevelOrAboveLevelNode(translatedDataKeys, selectedNode?.key, currentIndex, offset);
			if ((!Object.values(expandedKeys)?.filter(e => e === selectedNode.key)?.length && nextNodeKey?.indexOf(selectedNode?.key) !== -1)
				|| (!Object.values(expandedKeys)?.filter(e => e === translatedDataKeys[sameLevelOrAboveLevelNodeIndex]?.key)?.length && nextNodeKey?.indexOf(translatedDataKeys[sameLevelOrAboveLevelNodeIndex]?.key) !== -1 && offset === -1)
			) {
				nextNodeKey = translatedDataKeys[isNaN(sameLevelOrAboveLevelNodeIndex) ? currentIndex : sameLevelOrAboveLevelNodeIndex]?.key;
				nextNode = collectedNodes[nextNodeKey];
			}
			if (newIndex < 0 || newIndex >= translatedDataKeys.length || !nextNodeKey) {
				return;
			}

			setSelectedKeys([nextNodeKey]);
			dispatch(
				treeActions.setRightTreeSelectedNode({
					screen: parentScreen,
					type: currentTab,
					data: {},
				})
			);
			setTimeout(() => {
				dispatch(
					treeActions.setRightTreeSelectedNode({
						screen: parentScreen,
						type: currentTab,
						data: nextNode,
					})
				);
			})

		};
		if (event.key === "ArrowUp") {
			navigate(-1);
		} else if (event.key === "ArrowDown") {
			navigate(1);
		} else if (event.key === "ArrowRight") {
			expandAndCollapseNode(true);
		} else if (event.key === "ArrowLeft") {
			expandAndCollapseNode(false);
		} else if ((event.key === "Delete") && selectedKeys.length > 0) {
			// Trigger delete modal when Delete key is pressed and there are selected items
			setShowDeleteModal(true);
		}

	};

	//updates provided state with proper map, using an array of ids
	const updateNodesByIds = (ids, setState) => {
		let nodes = {};
		each(ids, (id) => {
			getNodeById(translatedData, id, (item) => {
				nodes[id] = item.key;
			});
		})
		setState(nodes);
	}

	const updateNodesByAltIds = (ids, setState) => {
		let nodes = {};
		each(ids, (id) => {
			getNodeByAltId(translatedData, id, (item) => {
				nodes[id] = item.key;
			});
		})
		setState(nodes);
	}

	useEffect(() => {
		if (!rightTree.loading && leftTree.tree.body.selectedNode?.type === "workflow") {
			// setExpandedKeys(translatedData?.length ? [translatedData[0]?.key] : []);
			// setSelectedKeys((prev) => translatedData?.length ? [translatedData[0]?.key] : []);
			// dispatch(
			// 	treeActions.setRightTreeSelectedNode({
			// 		screen: parentScreen,
			// 		type: "body",
			// 		data: translatedData?.[0] || {},
			// 	})
			// )
		}
	}, [rightTree.loading]);
    // updates selectedNode obj with given node
  const dispatchSelectedNode = (node) => {
    if (node) {
      dispatch(
        treeActions.setRightTreeSelectedNode({
          screen: parentScreen,
          type: currentTab,
          data: node,
        })
      );
    }
  }
    useEffect(() => {
      const updateSelectedNodeInRightTree = (
        visitedTemplates,
        templatePath,
        tab
      ) => {
        // Find the node in recentlyVisitedTemplates that matches the templatePath
        const matchedTemplate = visitedTemplates.find(
          (template) => template.path === templatePath && template.tab === tab
        );

        if (!matchedTemplate) {
          return translatedData[0]; // Return first node if no matching template is found in list of recently visited templates
        }

        let matchingNode = null;
        // Traverse translatedData to find the matching node by key
        eachDeep(cloneDeep(translatedData), (obj) => {
          if (obj?.key === matchedTemplate.key) {
            matchingNode = obj;
            return false;
          }
          if (Array.isArray(obj?.children)) {
            return obj.children;
          }
        });

        return matchingNode; // Return the matching node
      };
      if (
        leftTree.tree.body.selectedNode.type === "workflow" &&
        translatedData.length
      ) {
        const node = updateSelectedNodeInRightTree(
          recentlyVisitedTemplates,
          templatePath,
          currentTab
        );

        dispatchSelectedNode(node);
      }
    }, [leftTree.tree.body.selectedNode.key]);

	useEffect(() => {
		if (selectedNode?.key) {
			// const selectedNodeParentKey = selectedNode?.key?.split("-") || [];
			// 	selectedNodeParentKey?.pop();
			// 	if (
			// 		selectedNode?.key &&
			// 		selectedNodeParentKey?.length >= 2 &&
			// 		!expandedKeys.includes(selectedNodeParentKey?.join("-"))
			// 	) {
			// 		const parentKeys = getNodeParentsKeys(selectedNode?.key);
			// 		setExpandedKeys([...expandedKeys, ...parentKeys]);
			// 	}
			if (
				selectedNode.key &&
				!selectedKeys.includes(selectedNode?.key) &&
				!selectedNode?.avoidSelection
			) {
				setSelectedKeys((prev) => [selectedNode.key]);
				modifyRecentVisitedTemplates(selectedNode, currentTab)

			}
		}

		const updateExpNodes = () => {
			if (!selectedNode?.alternateNodeId) return;
			//filter duplicate expand ids caused by reindexing
			let filteredENI = [...new Set(Object.keys(expandedKeys))];
			if (selectedNode?.alternateNodeId) {
				if (filteredENI.length === 0 && selectedNode.alternateNodeId === translatedData[0]?.alternateNodeId) {
					// If the selected node is the first node, expand the first node
					filteredENI.push(selectedNode.alternateNodeId);
				}
				//if current selected node is inside a non-expanded parent, expand the parent to show the node.
				getNodeParentsByAltId(translatedData, selectedNode.alternateNodeId, (parentIdsArray = []) => {
					updateNodesByKeys([...new Set([...(Object?.values(expandedKeys)||[]), ...parentIdsArray, ...(selectedNode.alternateNodeId === translatedData?.[0]?.alternateNodeId ? [selectedNode?.key] : [])])], setExpandedKeys);
				});
			} else {

				//else update expanded nodes with filtered arr
				updateNodesByAltIds(filteredENI, setExpandedKeys);
			}
		}

		!fromOnExpand && updateExpNodes();
		setFromOnExpand(false);

	}, [translatedData, selectedNode])

	useEffect(() => {
		if (expandActions?.tab === props.tab) {
			const keys = Object?.values(expandActions.keys) || [];
			updateNodesByKeys(keys, setExpandedKeys);
		}
		// eslint-disable-next-line
	}, [expandActions]);

	const titleRenderHandler = (node) => {
		const description = node?.COMMENTS?.trim() || node?.DESCRIPTION?.trim();
		const tooltipText = description || node.title;
		
		return (
			<span style={{opacity: node?.ENABLED === "FALSE" ? "0.5" : "1"}} data-key={`${node.key}`} title={tooltipText}>
				<Badge
					color="primary"
					variant="dot"
					invisible={!node?.COMMENTS?.trim() && !node?.DESCRIPTION?.trim()}
					sx={{ '& .MuiBadge-dot': { right: 3, top: 4, position: "relative", width: 4, height: 4, minWidth: 4, minHeight: 4 } }}
				>
					<span>{node.title}</span>
				</Badge>
			</span>
		);
	};

	const Icon = (node) => {
    if (node.ICON_DISPLAY) {
      return <span id={node.data.key} className={"tree-icon " + (node.ICON_DISPLAY === "ACTION" && node?.ACTION_TYPE === "Stop All Workflow Processing" ? "STOP_ACTION" : node.ICON_DISPLAY)}></span>;
    } 
	};

	const switcherIcon = (obj) => {
		if (obj.isLeaf) return;
		if (obj.expanded) return <ArrowDropDownIcon />;
		else return <ArrowRightIcon sx={{ color: "#666666" }} />;
	};


	return (
    <>
      <div
        ref={treeParentRef}
        className="overflow-auto height-100"
        style={{userSelect: "none", height: "100%" }}
		onKeyDown={handleKeyDown}
		tabIndex={0}
        id="wf-tree">
        {!rightTree.loading ? (
          <Tree
            showLine
            multiple
            showIcon
            autoFocus
            focusable
            draggable
            selectable
            icon={Icon}
            ref={treeRef}
            disabled={treeDisabled}
            treeData={translatedData}
            selectedKeys={selectedKeys}
            // expandedKeys={expandedKeys}
			expandedKeys={expandedKeys ? Object.values(expandedKeys) : {}}
            onDrop={onDrop}
            onExpand={onExpand}
            onSelect={onSelect}
            onDragStart={onDragStart}
            onRightClick={onRightClick}
            switcherIcon={switcherIcon}
            titleRender={titleRenderHandler}
          />
        ) : (
          <TreeLoading />
        )}
      </div>
      <Dialog open={showModal}>
        <DialogTitle className="dialog-header title">
          <div className="title">{t("BOX_CONFIRM")}</div>
        </DialogTitle>
        <DialogContent className="dialog-content" dividers>
          <div className="alignToHeader">{modalContent}</div>
        </DialogContent>
        <DialogActions>
          <Button
            size="small"
            variant="outlined"
            color="primary"
            onClick={() => handleItemDrop(true)}>
            {t("BTN_YES")}
          </Button>
          <Button
            size="small"
            variant="outlined"
            color="primary"
            onClick={() => handleItemDrop(false)}>
            {t("BTN_NO")}
          </Button>
          <Button
            size="small"
            variant="outlined"
            color="primary"
            onClick={() => {
              // toggle(null);
              setShowModal(false);
            }}>
            {t("BTN_CANCEL")}
          </Button>
        </DialogActions>
		</Dialog>
		<ErrorModal
			errorModal={errorModal}
			errorMessage={errorMessage}
			handleErrorModal={setErrorModal}
		/>
		<Delete 
			openModal={showDeleteModal} 
			toggle={() => setShowDeleteModal(false)} 
		/>
		</>
	);
}

// Function to Get Shift Selection Keys;
const getShiftSelectedKeys = (keys, data) => {
	const firstKey = keys[keys.length - 2];
	const secondKey = keys[keys.length - 1];

	const { startKey, endKey } = getStartAndEndKey(firstKey, secondKey);
	const selectedKeys = [];
	eachDeep(data, (obj) => {
		const key = obj?.key;
		if (key && obj?.ICON_DISPLAY && checkValidKey(key, startKey, endKey)) {
			selectedKeys.push(key);
		}
	});
	return selectedKeys;

	function checkValidKey(key, startKey, endKey) {
		if (key === startKey || key === endKey) {
			return true;
		}

		const keyArray = key.split("-").splice(1);
		const startKeyArray = startKey.split("-").splice(1);
		const endKeyArray = endKey.split("-").splice(1);
		const keySize = keyArray.length;
		const startKeySize = startKeyArray.length;
		const endKeySize = endKeyArray.length;

		if (keySize < startKeySize) {
			// When Current Key is Smaller than Start Key Size and End Key Size
			if (keySize < endKeySize) {
				let isKeyValid1 = true;
				let isKeyValid2 = true;

				for (let i = 0; i < keySize; i++) {
					const num1 = Number(keyArray[i]);
					const num2 = Number(startKeyArray[i]);
					if (num1 < num2) {
						isKeyValid1 = false;
						break;
					}
					if (num1 > num2) {
						isKeyValid1 = true;
						break;
					}
				}
				if (startKey.includes(key)) isKeyValid1 = false;

				for (let i = 0; i < keySize; i++) {
					const num1 = Number(keyArray[i]);
					const num2 = Number(endKeyArray[i]);
					if (num1 > num2) {
						isKeyValid2 = false;
						break;
					}
					if (num1 < num2) {
						isKeyValid2 = true;
						break;
					}
				}
				if (key.includes(endKey)) isKeyValid2 = false;

				return isKeyValid1 && isKeyValid2;

				// When Current Key is Smaller than Start Key Size and greater than End Key Size
			} else if (keySize > endKeySize) {
				let isKeyValid1 = false;
				let isKeyValid2 = false;

				for (let i = 0; i < keySize; i++) {
					const num1 = Number(keyArray[i]);
					const num2 = Number(startKeyArray[i]);
					if (num1 < num2) {
						isKeyValid1 = false;
						break;
					}
					if (num1 > num2) {
						isKeyValid1 = true;
						break;
					}
				}
				if (startKey.includes(key)) isKeyValid1 = false;

				for (let i = 0; i < endKeySize; i++) {
					const num1 = Number(keyArray[i]);
					const num2 = Number(endKeyArray[i]);
					if (num1 < num2) {
						isKeyValid2 = true;
						break;
					}
					if (num1 > num2) {
						isKeyValid2 = false;
						break;
					}
				}
				if (endKey.includes(key)) isKeyValid2 = true;

				return isKeyValid1 && isKeyValid2;

				// When Current Key is Smaller than Start Key Size and equal End Key Size
			} else if (keySize === endKeySize) {
				let isKeyValid1 = true;
				let isKeyValid2 = false;
				for (let i = 0; i < keySize; i++) {
					const num1 = Number(keyArray[i]);
					const num2 = Number(startKeyArray[i]);
					if (num1 < num2) {
						isKeyValid1 = false;
						break;
					}
					if (num1 > num2) {
						isKeyValid1 = true;
						break;
					}
				}
				if (startKey.includes(key)) isKeyValid1 = false;

				for (let i = 0; i < endKeySize; i++) {
					const num1 = Number(keyArray[i]);
					const num2 = Number(endKeyArray[i]);
					if (num1 > num2) {
						isKeyValid2 = false;
						break;
					}
					if (num1 < num2) {
						isKeyValid2 = true;
						break;
					}
				}
				return isKeyValid1 && isKeyValid2;
			}
		} else if (keySize > startKeySize) {
			// When Current Key is greater than Start Key Size and smaller than End Key Size
			if (keySize < endKeySize) {
				let isKeyValid1 = true;
				let isKeyValid2 = false;

				for (let i = 0; i < startKeySize; i++) {
					const num1 = Number(keyArray[i]);
					const num2 = Number(startKeyArray[i]);
					if (num1 < num2) {
						isKeyValid1 = false;
						break;
					}
					if (num1 > num2) {
						isKeyValid1 = true;
						break;
					}
				}
				if (startKey.includes(key)) isKeyValid1 = true;

				for (let i = 0; i < keySize; i++) {
					const num1 = Number(keyArray[i]);
					const num2 = Number(endKeyArray[i]);
					if (num1 < num2) {
						isKeyValid2 = true;
						break;
					}
					if (num1 > num2) {
						isKeyValid2 = false;
						break;
					}
				}
				if (endKey.includes(key)) isKeyValid2 = true;

				return isKeyValid1 && isKeyValid2;

				// When Current Key is greater than Start Key Size and End Key Size
			} else if (keySize > endKeySize) {
				let isKeyValid1 = true;
				let isKeyValid2 = false;

				for (let i = 0; i < keySize; i++) {
					const num1 = Number(keyArray[i]);
					const num2 = Number(startKeyArray[i]);
					if (num1 < num2) {
						isKeyValid1 = false;
						break;
					}
					if (num1 > num2) {
						isKeyValid1 = true;
						break;
					}
				}
				if (startKey.includes(key)) isKeyValid1 = true;

				for (let i = 0; i < endKeySize; i++) {
					const num1 = Number(keyArray[i]);
					const num2 = Number(endKeyArray[i]);
					if (num1 < num2) {
						isKeyValid2 = true;
						break;
					}
					if (num1 > num2) {
						isKeyValid2 = false;
						break;
					}
				}
				if (endKey.includes(key) && endKeySize > keySize) isKeyValid2 = false;

				return isKeyValid1 && isKeyValid2;

				// When Current Key is greater than Start Key Size and equal to End Key Size
			} else if (keySize === endKeySize) {
				let isKeyValid1 = true;
				let isKeyValid2 = false;

				for (let i = 0; i < keySize; i++) {
					const num1 = Number(keyArray[i]);
					const num2 = Number(startKeyArray[i]);
					if (num1 < num2) {
						isKeyValid1 = false;
						break;
					}
					if (num1 > num2) {
						isKeyValid1 = true;
						break;
					}
				}
				if (startKey.includes(key)) isKeyValid1 = true;

				for (let i = 0; i < endKeySize; i++) {
					const num1 = Number(keyArray[i]);
					const num2 = Number(endKeyArray[i]);
					if (num1 < num2) {
						isKeyValid2 = true;
						break;
					}
					if (num1 > num2) {
						isKeyValid2 = false;
						break;
					}
				}
				if (endKey.includes(key) && endKeySize > keySize) isKeyValid2 = false;

				return isKeyValid1 && isKeyValid2;
			}
		} else {
			// When Current Key is equal to Start Key Size and smaller than End Key Size

			if (keySize < endKeySize) {
				let isKeyValid1 = true;
				let isKeyValid2 = true;

				for (let i = 0; i < startKeySize; i++) {
					const num1 = Number(keyArray[i]);
					const num2 = Number(startKeyArray[i]);
					if (num1 < num2) {
						isKeyValid1 = false;
						break;
					}
					if (num1 > num2) {
						isKeyValid1 = true;
						break;
					}
				}

				for (let i = 0; i < keySize; i++) {
					const num1 = Number(keyArray[i]);
					const num2 = Number(endKeyArray[i]);
					if (num1 > num2) {
						isKeyValid2 = false;
						break;
					}
					if (num1 < num2) {
						isKeyValid2 = true;
						break;
					}
				}
				if (endKeyArray.includes(key)) isKeyValid2 = true;

				return isKeyValid1 && isKeyValid2;

				// When Current Key is equal to Start Key Size and greater than End Key Size
			} else if (keySize > endKeySize) {
				let isKeyValid1 = false;
				let isKeyValid2 = false;

				for (let i = 0; i < startKeySize; i++) {
					const num1 = Number(keyArray[i]);
					const num2 = Number(startKeyArray[i]);
					if (num1 < num2) {
						isKeyValid1 = false;
						break;
					}
					if (num1 > num2) {
						isKeyValid1 = true;
						break;
					}
				}

				for (let i = 0; i < keySize; i++) {
					const num1 = Number(keyArray[i]);
					const num2 = Number(endKeyArray[i]);
					if (num1 > num2) {
						isKeyValid2 = false;
						break;
					}
					if (num1 < num2) {
						isKeyValid2 = true;
						break;
					}
				}

				return isKeyValid1 && isKeyValid2;

				// When Current Key is equal to Start Key Size and End Key Size
			} else if (keySize === endKeySize) {
				let isKeyValid1 = false;
				let isKeyValid2 = false;

				for (let i = 0; i < startKeySize; i++) {
					const num1 = Number(keyArray[i]);
					const num2 = Number(startKeyArray[i]);
					if (num1 < num2) {
						isKeyValid1 = false;
						break;
					}
					if (num1 > num2) {
						isKeyValid1 = true;
						break;
					}
				}

				for (let i = 0; i < keySize; i++) {
					const num1 = Number(keyArray[i]);
					const num2 = Number(endKeyArray[i]);
					if (num1 > num2) {
						isKeyValid2 = false;
						break;
					}
					if (num1 < num2) {
						isKeyValid2 = true;
						break;
					}
				}

				return isKeyValid1 && isKeyValid2;
			}
		}
	}
};

const getNodeParentsKeys = (key) => {
	if (!key) return [];
	const parentNodes = [];
	const keyArray = key.split("-");
	let tempKey = keyArray[0];
	for (let i = 1; i < keyArray.length; i++) {
		tempKey += `-${keyArray[i]}`;
		parentNodes.push(tempKey);
	}
	return parentNodes;
};

const getNodeByKey = (_data, key, callback) => {
	let exitLoop = false;
	const loopNode = (data) => {
		each(data, (item, index, arr) => {
			if (exitLoop) return false;
			if (item.key === key) {
				exitLoop = true;
				return callback(item, index, arr);
			}
			if (item.children) loopNode(item.children);
		})
	}
	return loopNode(_data);
};

// loop through tree data, return callback with node info if id is found, and exit loop.
const getNodeById = (_data, id, _callback) => {
	let exitLoop = false;
	const loopNode = (data) => {
	  each(data, (item, index, arr) => {
		if (exitLoop) return false;
		if (!item) return;
		if (item.nodeId === id) {
		  exitLoop = true;
		  return _callback(item, index, arr);
		}
		if (item.children) loopNode(item.children);
	  })
	}
	return loopNode(_data);
  };

  const getNodeByAltId = (_data, id, _callback) => {
	let exitLoop = false;
	const loopNode = (data) => {
	  each(data, (item, index, arr) => {
		if (exitLoop) return false;
		if (!item) return;
		if (item.alternateNodeId === id) {
		  exitLoop = true;
		  return _callback(item, index, arr);
		}
		if (item.children) loopNode(item.children);
	  })
	}
	return loopNode(_data);
  };